import { FontSize } from "../../assets/font";
import Color from "../../assets/colors";
import styled from "styled-components";
import withTheme from "@mui/styles/withTheme";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

// Grid Components //
export const Wrapper = withTheme(styled(Grid)`
  && {
    padding: 0 100px 100px 100px;
    margin: 0 auto;
    flex-wrap: wrap;
    display: flex;
    max-width: 90vw;

    ${(props) => props.theme.breakpoints.down("tabletS")} {
      padding: 0 50px 50px 50px;
      flex-wrap: nowrap;
      flex-direction: column;
    }
  }
`);
export const ContentContainer = styled(Grid)`
  && {
    margin: 0 20px 20px 20px;
    min-width: 200px;
  }
`;
export const LinksContainer = styled(Grid)`
  && {
    display: flex;
    flex-direction: column;
  }
`;
export const TitleContainer = withTheme(styled(Grid)`
  && {
    padding: 20px 100px 0 120px;
    margin: 0 auto;
    max-width: 90vw;

    ${(props) => props.theme.breakpoints.down("tabletS")} {
      padding: 20px 100px 0 70px;
    }
  }
`);

// Typography Components //
export const TitleStyled = styled(Typography)`
  && {
    font-weight: ${FontSize.bold};
    font-size: ${FontSize.desktopHeader};
    margin: 30px 0 15px 0;
  }
`;
export const SubtitleStyled = styled(Typography)`
  && {
    font-weight: ${FontSize.bold};
    font-size: ${FontSize.desktopBody};
    margin: 0 0 10px 0;
  }
`;

// Link Components //
export const LinkStyled = styled(Link)`
  && {
    font-size: ${FontSize.desktopCaption};
    color: ${Color.black};
    margin: 0 0 10px 0;
    text-decoration: none;

    & :hover {
      text-decoration: none;
      color: ${Color.hiredlyPurple};
      font-weight: ${FontSize.bold};
    }
  }
`;
